import { List, Create, Edit, View, MyPending } from "../Components/index.js";

export default [
    {
        path: "/bq-store/note-sheet",
        component: List,
        name: "bq-store.note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/note-sheet/create",
        component: Create,
        name: "bq-store.note-sheet.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/note-sheet/:id/edit",
        component: Edit,
        name: "bq-store.note-sheet.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/note-sheet/:id/view",
        component: View,
        name: "bq-store.note-sheet.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/note-sheet-my-pending",
        component: MyPending,
        name: "bq-store-my-note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
];
